import { render } from "./EditsSectionContainer.vue?vue&type=template&id=2eb54e3c&ts=true"
import script from "./EditsSectionContainer.vue?vue&type=script&lang=ts"
export * from "./EditsSectionContainer.vue?vue&type=script&lang=ts"

import "./EditsSectionContainer.vue?vue&type=style&index=0&id=2eb54e3c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QList,QItem,QIcon,QTooltip});
